// removed by extract-text-webpack-plugin
module.exports = {"avatarBox":"_2YFKbqB5wrTjbahapmkD2_","avatar":"HOaWfNfSuqY6m3F_cwNqW","bullet":"_1GcnTgRa8qBoYbpnZiWDs1","link":"_2AkEqpbFkrCNN3c0CG7TSN"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/atoms/Avatar/style.css
// module id = 385
// module chunks = 37